import { defineMessages } from 'react-intl';

export const heidi2GetStartedChecklistMessages = defineMessages({
  title: {
    defaultMessage: 'Get started',
    id: '/hhinNZumb',
    description: 'Heading of the Heidi II "Get started" checklist on Home',
  },
  progress: {
    defaultMessage: '{done} of {total}',
    id: 'GQuqRyj4nU',
    description:
      'How many Heidi II "Get started" checklist items are done, e.g. "1 of 4"',
  },
  progressLabel: {
    defaultMessage: 'Getting started progress',
    id: '7yPj4g9SO+',
    description:
      'Accessible label for the progress bar on the Heidi II "Get started" checklist',
  },
  collapse: {
    defaultMessage: 'Collapse checklist',
    id: 'rgFdzt1Rdh',
    description: 'Accessible label for folding the Heidi II "Get started" checklist down',
  },
  expand: {
    defaultMessage: 'Expand checklist',
    id: '2viSxmCkJK',
    description:
      'Accessible label for opening the folded Heidi II "Get started" checklist',
  },
  moreActions: {
    defaultMessage: 'More actions',
    id: 'SHsqCz/1HO',
    description:
      'Accessible label and tooltip for the overflow menu on the Heidi II "Get started" checklist',
  },
  readGuide: {
    defaultMessage: 'Read guide',
    id: '3In77qCwRR',
    description:
      'Heidi II "Get started" checklist overflow menu item that opens the getting started help article in a new tab',
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    id: 'qduIQx3fI6',
    description:
      'Heidi II "Get started" checklist overflow menu item that closes the checklist for good',
  },
  itemWelcomeTour: {
    defaultMessage: 'Complete welcome tour',
    id: 'mqVsK++qED',
    description: 'Heidi II "Get started" checklist item that reopens the Heidi II tour',
  },
  itemGiveTask: {
    defaultMessage: 'Give Heidi a task',
    id: '/Kuctfegoc',
    description:
      'Heidi II "Get started" checklist item that opens Home to hand Heidi a task',
  },
  itemConnectApps: {
    defaultMessage: 'Connect your apps',
    id: 'e/+FAl95ZW',
    description:
      'Heidi II "Get started" checklist item that opens the connected apps settings',
  },
  itemRunRoutine: {
    defaultMessage: 'Run a routine',
    id: '2jVKYChi1c',
    description: 'Heidi II "Get started" checklist item that opens Routines',
  },
  itemDone: {
    defaultMessage: 'Done',
    id: 'Is+PP4Zw0M',
    description:
      'Screen-reader suffix on a completed Heidi II "Get started" checklist item',
  },
  moreHelp: {
    defaultMessage: 'Want some help?',
    id: 'Pjvv1z98/0',
    description:
      'Prompt beside the book-a-call button on the Heidi II "Get started" checklist',
  },
  bookingReceived: {
    defaultMessage: 'Booking received',
    id: 'zbKGmONvfW',
    description:
      'Replaces the book-a-demo prompt on the Heidi II "Get started" checklist once the clinician has booked',
  },
  bookDemo: {
    defaultMessage: 'Book a call',
    id: 'Wh/43AzdAi',
    description:
      'Button on the Heidi II "Get started" checklist that opens the demo booking form',
  },
});
